import { Link, useParams } from "react-router-dom";
import { Cancel, PlaylistAdd, Search } from "@mui/icons-material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useFetch from "./useFetch";
import { useRef, useState, useContext, useEffect } from "react";
import ReactPlayer from "react-player";
import { Button, CircularProgress } from "@mui/material";
import shareicon from "./otherImg/hbrshare.png";
import Send from "@mui/icons-material/Send";
import { Timestamp, addDoc, collection, doc, onSnapshot, orderBy, query, setDoc, where } from "firebase/firestore";
import db from "./firebase";
import { AuthContext } from "./AuthContext";
import VideoCommentsDisplay from "./VideoCommentsDisplay";
import { addToWatchList, addVideoToDB, initDB } from "./ConfigureIndexDB";
import format from "date-fns/format";

const VideoPlayerdual = () => {
    const {id} = useParams();
    const [commentText,setCommentText]=useState();
    const [err,setError]=useState(false);
    const [savedMessage,setSavedMessage]=useState(false);
    const [videoviews,setVideoViews]=useState([]);
    const [usernotfound,setUsernotfound]=useState(false);
    const [searchVideo,setSearchVideo]=useState("");
    const [searchResults,setSearchResults]=useState("");
    const [isSerachFound,setIsSearchFound]=useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchAvailable,setAvailableResults]=useState(false);
    const [showTextarea,setShowCommentArea]=useState(false);
    const [playing,setPlaying]=useState(true);
    const [showPause,setShowPause]=useState(false);
    const [showSeekBar,setShowSeekbar]=useState(false);
    const [played, setPlayed] = useState(0);
    const [trackPlayed, setTrackPlayed] = useState(0);
    const [duration, setDuration] = useState(0);
    const playerRef = useRef(null);
    const now = Timestamp.now();
    const utcTime = new Date(now?.toDate()).toUTCString();
    const timestamp = new Date().getTime();

    const {data:videoMessage,ispending,erroralert} = useFetch(`${process.env.REACT_APP_VIDEOS}/`+id);
    const {userName} = useContext(AuthContext);
    const {verifiedUid} = useContext(AuthContext);
    const {user_email} = useContext(AuthContext);

    const videoQuery =(e)=>{
        e.preventDefault();
        if(videoMessages){
            let result = videoMessages.filter(videoData =>
                videoData.title.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchVideo.toLowerCase())
              );
              if(result.length > 0){
                setFilteredData(result);
                setAvailableResults(true);
                setIsSearchFound(true);
              }else{
                setSearchResults(`No video match for ${searchVideo}. Video may either be unavailable or try checking for any spelling or grammatical errors`);
                setAvailableResults(true);
                setIsSearchFound(false);
              }
    };
    };
    const handleProgress = (progress) => {
        setPlayed(progress.playedSeconds);
        setTrackPlayed(progress.played);
    };
    const handleDuration = (duration) => {
        setDuration(duration);
    };
    const handleSeekChange = (e) => {
        setTrackPlayed(parseFloat(e.target.value) / duration);
        playerRef.current.seekTo(parseFloat(e.target.value) / duration);
    };
    const showVideoControls=()=>{
        setShowPause(true);
        setShowSeekbar(true);
     
    };
    const hideVideoControls=()=>{
        setShowPause(false);
       const timeid = setTimeout(()=>{
            setShowSeekbar(false);
        },5000); 
        return ()=>clearTimeout(timeid);
    };
    const handlePlayBtnClicked=()=>{
        setPlaying(true);
        setShowPause(false);
    };
    const handleplay=()=>{
        setPlaying(true);
        setShowPause(false);
    };
    const handlepause=()=>{
        setPlaying(false);
        setShowPause(false);
        setShowSeekbar(true);
    };
    const handlePauseBtnClicked=()=>{
        setPlaying(false);
        setShowPause(false);
    };
    const home =()=>{
        setSearchVideo("");
        setAvailableResults(false);
        setIsSearchFound(false);
    };
    const formatTime = (seconds) => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
    
        return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
      };
    const {data:videoMessages,ispending2,erroralert2} = useFetch(`${process.env.REACT_APP_VIDEOS}`);

    const saveVideo=()=>{
        if(videoMessage){
            const videoID = videoMessage.id;
            const vidTitle = videoMessage.title;
            const vidUrl = videoMessage.videoUrl;
            const vidImage = videoMessage.image;
            initDB().then(()=>{
                addVideoToDB({
                    id:videoID,
                    vidTitle,
                    vidUrl,
                    vidImage
                }).then(()=>{
                    setSavedMessage(true);
                }).catch((error)=>{
                    console.log(error);
                    alert(("something went wrong, try again or contact the support team"));
                });
            });
        }
    };
    const shareVideo=async()=>{
        if(navigator.share && videoMessage){
            try{
                await navigator.share({
                    title:videoMessage.title,
                    url: `https://horemowbookreaderlite.web.app/horemow_video_hbr/${videoMessage.title}/${videoMessage.id}`,
                    text: `${videoMessage.title} \n https://horemowbookreaderlite.web.app`,
                });
            }catch(error){
                console.log(error);
            }
        }else{
            alert("Browser not supported, Try using chrome or Safari or Edge browser");
        }
    };

    useEffect(()=>{
        if(videoMessage){
            const collectionRef = collection(db,"views");
            const q = query(collectionRef,where("messageTitle","==",videoMessage.title),orderBy("timestamp","desc"));
            if(collectionRef){
                try{
                    const unsub = onSnapshot(q,(snapshot)=>{
                        const getViews = [];
                        snapshot.forEach((doc)=>{
                            getViews.push(doc.data());
                        });
                        setVideoViews(getViews);
                    });
                    return unsub;
                }catch(error){
    
                }
            }
        }
 
    },[videoMessage]);

    useEffect(()=>{
        const videoviews=async()=>{
            if(videoMessage){
                if(!sessionStorage.getItem(`${videoMessage.title}`)){   
                    const timestamp = new Date().getTime();
                    const today = new Date();
                    const formatToday = format(today,"yyyyMMddHHmmss");
                    const now = Timestamp.now();
                    const utcTime = new Date(now?.toDate()).toUTCString();             
                    try{
                        await setDoc(doc(db,"views",formatToday),{
                            messageTitle: videoMessage.title,
                            DateVisited: utcTime,
                            messageID: formatToday,
                            thumbnail: "",
                            timestamp: timestamp
                        });
                        sessionStorage.setItem(`${videoMessage.title}`,"saved");
                    }catch(error){
                        
                    }
                }else{
                    sessionStorage.setItem(`${videoMessage.title}`,"saved");
                }
                initDB().then(()=>{
                    const videoID = videoMessage.id;
                    const vidTitle = videoMessage.title;
                    const vidUrl = videoMessage.videoUrl;
                    const vidImage = videoMessage.image;
                    addToWatchList({
                        id:videoID,
                        vidTitle,
                        vidUrl,
                        vidImage,
                        year:"2023"
                    }).catch((error)=>{
                        console.log(error);
                    });
                })
            }
        }
        videoviews();
    },[videoMessage]);
   
    const sendVidComment=async()=>{
        if(verifiedUid){
            if(commentText !== "" && videoMessage){
                try{
                  const docref = await addDoc(collection(db,"Video Comments"),{
                        comment:commentText,
                        date_sent:utcTime,
                        message_title:videoMessage.title,
                        timestamp,
                        userName,
                        user_email
                    });
                    sessionStorage.setItem(`${timestamp}`,docref.id);
                    setCommentText("");
                    setShowCommentArea(false);
                }catch(error){
                    setError(true);
                }
            }
        }else{
            setUsernotfound(true);
        }
    };


    return (  
        <div className="videoplayer">
           {erroralert && 
            <div style={{
                position:"fixed",
                left:"50%",
                top:"20rem"
                }}>
                {erroralert}
            </div>}
             {ispending &&
            <div style={{
                position:"fixed",
                left:"50%",
                top:"20rem"
                }}> 
             <CircularProgress/> <br/>
            loading...
            </div>
            } 
            <div className="videopagetop">
                <div className="searchvideomessages">
                   {searchAvailable && <button id="backarrow" onClick={home}><ArrowBackIcon/></button>} 
                    <form onSubmit={videoQuery}>
                    <input type="search" placeholder="search" value={searchVideo} onChange={e => setSearchVideo(e.target.value)}/>
                    </form>
                    <button id="search_btn" onClick={videoQuery}><Search/></button> 
               </div>

               <div className="videotoplargescreen">
               <h4 
                style={{
                color: "black",
                fontWeight: "bold" 
              }}
               >Messages <span style={{color:"orangered"}}>{videoMessages && videoMessages.length}</span>
               </h4> 
               </div>

               <div className="videotopphone">
               <h4 
                style={{
                color: "orangered",
                fontWeight: "bold" 
              }}>
                {videoMessages && videoMessages.length}
               </h4> 
               </div>
         
            </div>

          <div className="videoPlayerBody">
          <div className="videoSelectedbody">
                    <div className="videoplayer_view" onMouseEnter={showVideoControls} onMouseLeave={hideVideoControls}>
                            {videoMessage && showPause && <div className="playeroverlay"></div>} 
                                {videoMessage && !playing &&
                                        <svg
                                        id="playVideoBtn"
                                        onClick={handlePlayBtnClicked}
                                        viewBox="0 0 24 24"
                                        fill="white">
                                        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
                                        <path d="M9 17l8-5-8-5z" />
                                        </svg>
                                }
                                {videoMessage && showPause && playing &&
                                        <svg
                                        onClick={handlePauseBtnClicked}
                                        id="playVideoBtn"
                                        viewBox="0 0 24 24"
                                        fill="white">
                                        <path d="M8 7h3v10H8zm5 0h3v10h-3z" />
                                        </svg>
                                }
                                {videoMessage && <ReactPlayer
                                ref={playerRef}
                                onProgress={handleProgress}
                                onDuration={handleDuration}
                                playing={playing} 
                                width="100%" 
                                height="100%" 
                                onPlay={handleplay}
                                onPause={handlepause}
                                config={{
                                    youtube:{
                                        playerVars:{
                                            modestbranding:1,
                                            controls:0,
                                            showinfo:0
                                        }
                                    }
                                }}
                                url={videoMessage.videoUrl}/>
                                }

                                {
                                    videoMessage && showSeekBar &&
                                    <div className="seekbarholder">
                                        <input
                                        className="seekbar"
                                        type='range' min={0} max={duration} step='any'
                                        value={trackPlayed * duration}
                                        onChange={handleSeekChange}/>

                                        <div className="videoTime">
                                        <p>{formatTime(played)} / {formatTime(duration)}</p> 
                                        </div>
                                    </div>
                                }
               
                    </div>
                    <div className="otherVidDetails">
                        <div className="videoselect_title_views">
                            <h3>Views {videoviews && videoviews.length}</h3>
                            <p>{videoMessage && videoMessage.title}</p>
                        </div>
                        <div className="video_cmd_buttons_holder">
                            {
                                !showTextarea && 
                                <div className="commenttrigger" onClick={()=>setShowCommentArea(prev => !prev)}> 
                                <h3>Add Comment</h3>  
                                </div>
                            }
                    
                            {
                                showTextarea && 
                                <div className="commenttextarea">
                                <textarea rows={5} placeholder="write comment" value={commentText} onChange={e=>setCommentText(e.target.value)}/>
                                <button onClick={sendVidComment}><Send/></button>
                                </div>
                            }

                            {
                                err &&
                                <div className="errAlert">
                                <h3>Error sending Message</h3>
                                <h4>Something went wrong on our side. Contact support Team if error persist</h4>
                                <Button onClick={() => setError(false)}
                                style={{backgroundColor:"white"}}>
                                    Cancel
                                </Button>
                                </div>
                            }

                            {
                                savedMessage &&
                                <div className="toast">
                                    <span style={{color:"white",fontWeight:"bold"}}>Message saved successfully</span> 
                                    <button onClick={()=>setSavedMessage(false)}><Cancel/></button>
                                </div>
                            }
                        
                            <div className="vidInteractiveIcons">
                                <div className="subvidinteractivebtnholder">
                                    <span>Save Video</span> <button onClick={saveVideo}><PlaylistAdd/></button>
                                </div>
                            
                                <div className="subvidinteractivebtnholder">
                                    <span>Share </span> <img src={shareicon} alt="share video" onClick={shareVideo}/>
                                </div>
                            </div>
                        </div>
                        <div className="commentsdisplay">
                            {videoMessage && 
                            <VideoCommentsDisplay videoTitle={videoMessage.title}/>
                            }
                        <div className="morevidsphone">
                        <h4>Full screen is not currently supported, will be included in later updates.</h4>   
                        <h3>More Videos below</h3>
                        </div>
                        </div>
                    </div>
            </div>

            {usernotfound && 
                  <div className="toast2">
                  <p style={{color:"white",fontWeight:"bold"}}>
                    Action revoked, user not found. This alert often shows if user has no account.
                    <a style={{backgroundColor:"white"}} href='/account/create'> Click here to create your account</a>  and continue with the app. 
                 </p> 
                    <svg
                    cursor="pointer"
                    onClick={()=>setUsernotfound(false)}
                    viewBox="0 0 24 24"
                    fill="white"
                    height="30px"
                    width="30px">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                    </svg>
              </div>
              }

            <div className="videoPlayerSidebar">
                {erroralert2 && <div>{erroralert2}</div>}
                {ispending2 &&
                    <div> 
                    <CircularProgress/> <br/>
                    related videos...
                    </div>
                }
               
                {searchAvailable && !isSerachFound && <h3>{searchResults}</h3>}
                    {searchAvailable && isSerachFound &&
                    filteredData.map((videoData) => (
                        <div className="vidDispalySidebar" key={videoData.id}>
                          <Link className="vidDispalySidebar2" to={`/hrmw_video_hbr/${videoData.title}/${videoData.id}`}>
                            <img src={videoData.image} alt="video thumbnail"/>
                            <div className="vidtitle_id">
                              <h3>HBR {videoData.id}</h3>
                              <h3>{videoData.title}</h3>
                            </div>

                            <svg
                            width="2.5em"
                            height="2.5em"
                            viewBox="0 0 24 24"
                            fill="white">
                            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
                            <path d="M9 17l8-5-8-5z" />
                            </svg>
                          </Link>
                        </div>
                      ))}

                {!searchAvailable && videoMessage && videoMessages && videoMessages.map((videoData) => (
                    <div className="vidDispalySidebar" key={videoData.id}>
                    <Link className="vidDispalySidebar2" to={`/hrmw_video_hbr/${videoData.title}/${videoData.id}`}>
                        <img src={videoData.image} alt="video thumbnail"/>
                        <div className="vidtitle_id">
                            <h3>HBR {videoData.id}</h3>
                            <h3>{videoData.title}</h3>
                        </div>

                        <svg
                            width="2.5em"
                            height="2.5em"
                            viewBox="0 0 24 24"
                            fill="white">
                            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
                            <path d="M9 17l8-5-8-5z" />
                            </svg>
                    </Link>
                    </div>
                ))
                } 
                </div>
          </div>
    </div>
    );
}
export default VideoPlayerdual;